import * as React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

export default function Drawer({
  children,
  anchor = "right",
  open,
  setOpen,
  // Top padding to clear a fixed header. Defaults to the v1 layout's 58px;
  // the v2 (modern) shell overlays the drawer above the header, so it passes
  // a small value to avoid the large empty gap.
  topOffset = 58,
  ...other
}) {
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(!open);
  };

  return (
    <SwipeableDrawer
      anchor={anchor}
      open={open || false}
      onClose={toggleDrawer(anchor, false)}
      onOpen={toggleDrawer(anchor, true)}
      PaperProps={{
        className: "!rounded-none min-w-[350px]",
        style: { paddingTop: typeof topOffset === "number" ? `${topOffset}px` : topOffset },
      }}
      swipeAreaWidth={0}
      {...other}
    >
      {children}
    </SwipeableDrawer>
  );
}
